module.exports = __webpack_public_path__ + "static/media/imgGallery2.bdc5cdcc.jpg";